/**
 * theme.customPhotoPricing — the arithmetic behind the price shown on the custom-photo PDP.
 *
 * On the POSTER the frame is a separate product, added as a second cart line. The customer
 * still expects the headline price to be what they will pay, so the controller
 * (main-product-custom-photo.js) folds the selected frame's price into the displayed price
 * before the photo is even uploaded — the same figure the CANVAS shows naturally, because
 * there the frame is inside the variant.
 *
 * Pure functions, no DOM, so they are unit-tested in util.custom-photo-pricing.test.mjs.
 */
(function () {
  window.theme = window.theme || {};

  function cents(value) {
    var n = Number(value);
    return isFinite(n) && n > 0 ? Math.round(n) : 0;
  }

  /**
   * @param {{priceCents:number, compareCents?:number}} variant  the selected product variant
   * @param {number|string|null} frameDeltaCents  the selected frame's price in this size, 0/null for none
   * @returns {{priceCents:number, compareCents:number, onSale:boolean}}
   *   The "Spar 50%" badge is deliberately NOT part of this: it is the merchant's fixed
   *   campaign text and stays as the theme renders it, frame or no frame.
   */
  function compose(variant, frameDeltaCents) {
    var delta = cents(frameDeltaCents);
    var price = cents(variant && variant.priceCents) + delta;
    var baseCompare = cents(variant && variant.compareCents);
    var compare = baseCompare > 0 ? baseCompare + delta : 0;
    return { priceCents: price, compareCents: compare, onSale: compare > price };
  }

  theme.customPhotoPricing = { compose: compose };
})();
